import { MdOutlineEmail } from "react-icons/md";
import { Link } from "react-router-dom";
import { Button, Card, Col, Row } from "reactstrap";
import { AuthHalfScreenComp } from "../../components/commonComponents";
import CodeInput from "../../components/inputs/CodeVerification";
import IconInput from "../../components/inputs/IconInput";
import ErrorModal from "../../components/modals/ErrorModal";
import useAuthHooks from "../../hooks/useAuthHooks";
import { useTranslation } from "../../languages";

const ForgotPassword = () => {
  const {
    //all local states
    forgotCredintials,
    setForgotCredentials,
    isEnteringCode,

    //all functions
    onPressConfirmBtn,
    onPressConfirmVerifyBtn,
    onPressResendCodeBtn,
    onPressConfirmSuccessfulyCodeSendForgotPassword,
    onPressResetPasswordConfirmBtn,
  } = useAuthHooks();
  const { t } = useTranslation();

  return (
    <Row className="full-screen m-0">
      <AuthHalfScreenComp />
      <Col
        md={6}
        lg={5}
        className="d-flex py-3 align-items-center justify-content-center"
      >
        <Card className="bg-transparent border-none full-width mx-xl-5 mx-4">
          <h4 className="f-7">
            {isEnteringCode ? t("verifyCode") : t("forgotPasswordTitle")}
          </h4>
          <h5 className="f-4 m-0">
            {isEnteringCode ? t("enterCodeFromEmail") : t("enterEmailToSearch")}
          </h5>
          <div className="mt-4 mb-3">
            {isEnteringCode ? (
              <CodeInput
                code={forgotCredintials?.code}
                onChange={(e) =>
                  setForgotCredentials((prev) => ({ ...prev, code: e }))
                }
              />
            ) : (
              <IconInput
                Icon={MdOutlineEmail}
                className={"mb-3"}
                placeholder={"Email Address"}
                type={"email"}
                value={forgotCredintials?.email}
                setValue={(e) =>
                  setForgotCredentials((prev) => ({ ...prev, email: e }))
                }
              />
            )}
          </div>
          <Button
            onClick={
              isEnteringCode ? onPressConfirmVerifyBtn : onPressConfirmBtn
            }
            // onClick={() => onAuthSuccess({ type: "user" })}
            className="standard-rounded-btn  py-3 mb-2 full-width"
          >
            {isEnteringCode ? t("verifyCode") : t("confirmAction")}
          </Button>

          {isEnteringCode ? (
            <div className="d-flex gap-1 mb-5 justify-content-end  flex-wrap">
              <Button
                className="color-primary-blue m-0 f-5 text-decoration-none bg-transparent border-none"
                onClick={onPressResendCodeBtn}
              >
                {t("resendCode")}
              </Button>
            </div>
          ) : (
            <div className="d-flex gap-2 mb-5 justify-content-center align-items-center flex-wrap">
              <span className="color-half-black">{t("backToLogin")}</span>
              <Link to={"/login"} className="text-black text-decoration-none">
                {t("login")}
              </Link>
            </div>
          )}
        </Card>
      </Col>

      <ErrorModal
        isOpen={forgotCredintials?.successMessage}
        success={true}
        onConfirmBtn={isEnteringCode ? false : true}
        onConfirm={
          isEnteringCode
            ? onPressResetPasswordConfirmBtn
            : onPressConfirmSuccessfulyCodeSendForgotPassword
        }
        toggle={() =>
          setForgotCredentials((prev) => ({ ...prev, successMessage: "" }))
        }
        errorMessage={forgotCredintials?.successMessage}
      />
    </Row>
  );
};

export default ForgotPassword;
